import styled from 'styled-components'
import { Text, Link as UikitLink, Flex, Box, scrollbarHidden } from 'vvs-uikit'
import GotchiActionButton from 'views/VvsGotchi/components/ActionButton'

function _makeMenuItemComp<T>(Comp: React.FC<T>) {
  return styled(Comp)`
    width: auto;
    transition: 0.5s background-color;
    background-color: transparent;
    cursor: pointer;

    &:hover {
      text-decoration: none;
      background-color: #00000080;
    }

    padding-left: 1em;
    padding-right: 1em;

    ${({ theme }) => theme.mediaQueries.sm} {
      padding-left: 2em;
      padding-right: 2em;
    }
  `
}

export const LinkItem = _makeMenuItemComp(UikitLink)
export const FlexItem = _makeMenuItemComp(Flex)

export const MenuDrawerContentFlex = styled(Flex)`
  height: 100%;
  flex-direction: column;
  overflow: hidden auto;
  ${scrollbarHidden}
`

export const LogoImg = styled.img`
  height: 16px;
`

export const Split = styled(Box)`
  width: 125px;
  height: 3px;
  background: white;
`

export const EmptyIcon = styled(Box)`
  background: yellow;
`

export const FullAccountText = styled(Text)`
  color: black;
  overflow-wrap: anywhere;
`

export const SwtichNetworkBtn = styled(GotchiActionButton)`
  margin-top: 2em;
`
